import React from 'react';

import { useGetAppointment } from '@hooks/api/appointment';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import Content from './Content';

const Appointment: React.FC<{ id?: string }> = ({ id = '' }) => {
  const {
    state: { activeProfile, isCurator },
  } = useSession();
  const [patient_id] = [activeProfile?.patient_id];
  const {
    state: { isCreating, isEditing },
    stopEditingRecord,
    finishAddingRecord,
  } = useCuration();

  const { data, loading } = useGetAppointment({
    record_id: id,
  });

  const handleSubmit = () => {
    stopEditingRecord();
    finishAddingRecord();
  };

  return (
    <Content
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default Appointment;
